import React, { Component } from 'react';
import classNames from 'classnames';
import icons from '../../assets/comet/comet.svg';
import './styles.styl';
import transcript from '../../assets/images/global-transcript.svg';

class AudioToggles extends Component {
  getClassNames = (cvsSPMSButtonName, enabled) => {
    let classes = {
      'audio-buttons__button': true,
      'audio-buttons__button--enabled': enabled
    };
    classes['audio-buttons__' + cvsSPMSButtonName] = true;
    classes['audio-buttons__' + cvsSPMSButtonName + '--enabled'] = enabled;

    return classNames(classes);
  };

  toggleAudio = () => {
    this.props.audioChange(!this.props.audioEnabled);
  };

  toggleTranscript = () => {
    this.props.transcriptChange(!this.props.transcriptEnabled);
  };

  render() {
    const { hidden } = this.props;

    return (
      <div className="audio-buttons">
        <button
          aria-pressed={this.props.audioEnabled}
          className={this.getClassNames(
            'audio-toggle',
            this.props.audioEnabled
          )}
          onClick={this.toggleAudio}
        >
          <svg className="comet-icon--m" aria-hidden="true" focusable="false">
            <use xlinkHref={`${icons}#asset-audio`} />
          </svg>
          <span className="comet-screenreader-only">Toggle Audio</span>
        </button>
        {!hidden && (
          <button
            aria-pressed={this.props.transcriptEnabled}
            className={this.getClassNames(
              'transcript-toggle',
              this.props.transcriptEnabled
            )}
            onClick={this.toggleTranscript}
          >
            <img src={transcript} alt="transcript" />
            {/*<svg className="comet-icon--m" aria-hidden="true" focusable="false">*/}
            {/*<use xlinkHref={`${icons}#document`} />*/}
            {/*</svg>*/}
            <span className="comet-screenreader-only">Toggle Transcript</span>
          </button>
        )}
      </div>
    );
  }
}

export default AudioToggles;



// WEBPACK FOOTER //
// ../core/src/components/AudioToggles/AudioToggles.js